import React from 'react';

import { AnchorButton, Intent } from "@blueprintjs/core";

import './index.css';

const _Button = ({ children, disabled, btnType, loading, onClick, svgIcon, ...rest }) => {
  let intent;

  switch (btnType) {
    case 'none':
      intent = Intent.NONE;
      break;
    case 'success':
      intent = Intent.SUCCESS;
      break;
    case 'danger':
      intent = Intent.DANGER;
      break;
    case 'warn':
      intent = Intent.WARNING;
      break;
    default:
      intent = Intent.PRIMARY;
      break;
  }

  return (
    <AnchorButton
      disabled={disabled}
      className={`button`}
      intent={intent}
      loading={loading}
      onClick={e => !disabled && !loading && onClick && onClick(e)}
      {...rest}
    >
      {svgIcon &&
        <img alt='icon' className='custom-button__icon' src={svgIcon} />
      }

      {children}
    </AnchorButton>
  );
};

export default _Button;